import { Injectable } from '@angular/core';
import { WebSocketService } from '../../../shared/shared-services/pubsub/web.socket.service';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

export interface JobNotification {
  subscriptionId: string;
  taskId: string;
  jobId: string;
  execStatus: string;
  execStartTs: Date;
  execEndTs: Date;
}

@Injectable({
  providedIn: 'root'
})
export class SchedulerNotificationService {
  constructor(private readonly webSocketService: WebSocketService) { }

  // subscribe to the job channel
  public subscribeToJobs(): Observable<JobNotification> {
    return this.webSocketService.getOrCreateInstance().pipe(
      switchMap(instance => {
        return instance.subscribe('jobs').onEventReceived.pipe(
          map(message => {
            return {
              subscriptionId: message.subscriptionId,
              taskId: message.data.taskId,
              jobId: message.data.jobId,
              execStatus: message.data.execStatus,
              execStartTs: new Date(message.data.execStartTs),
              execEndTs: new Date(message.data.execEndTs),
            };
          })
        );
      })
    );
  }

  public subscribeToJobById(jobId: string): Observable<JobNotification> {
    return this.subscribeToJobs().pipe(
      filter(job => job.jobId === jobId)
    );
  }
}
